import { VIEW_TITLES, varsayilanGorunum } from "./nav.js";
import { gorebilir } from "./domain/auth.js";
import { cls, staffOf } from "./domain/context.js";
import { state } from "./state.js";

// ---------- Yönlendirme ----------
// #/siniflar/papatya biçimi sınıf detayını açar, diğerleri düz görünüm.
//
// Kabuktan ayrı durur: görünümler de yönlendirme yapabilmeli
// (örneğin yeni personel kaydedildikten sonra detayına gitmek) ve
// app-shell zaten görünümleri içe aktardığı için ters yönde
// bağımlılık kurulamaz.
export function routeFromHash() {
  const [id, param] = location.hash.replace("#/", "").split("/");
  state.classId = null;
  state.staffId = null;
  // Bilinmeyen ya da role kapalı görünüm → rolün açılış ekranı.
  // Menüde görünmemesi yetmez; adres çubuğuna elle yazılırsa da açılmamalı.
  if (!VIEW_TITLES[id] || !gorebilir(id)) { state.view = varsayilanGorunum(); return; }
  state.view = id;
  if (id === "siniflar" && param && cls(param)) state.classId = param;
  if (id === "personel" && param && staffOf(param)) state.staffId = param;
}
